const generic = 'There was an error processing the confirmation.';

/** The server's reason for refusing a confirmation link, or a generic line. */
export function refusalMessage(response: unknown): string {
    const data = (response as { data?: unknown } | null | undefined)?.data as
        { message?: unknown; modelState?: Record<string, unknown> } | null | undefined;

    const reasons = data && data.modelState
        ? Object.values(data.modelState).flatMap(v => Array.isArray(v) ? v : [v]).filter((v): v is string => typeof v === 'string' && v.length > 0)
        : [];

    if (reasons.length > 0) {
        return reasons.join(' ');
    }

    // Web API's wording for a model-state refusal, which says nothing on its own.
    if (data && typeof data.message === 'string' && data.message && data.message !== 'The request is invalid.') {
        return data.message;
    }

    return generic;
}
